module.exports = __webpack_public_path__ + "static/media/A33.249e14cf.jpg";